import React                from 'react';
import PropTypes            from 'prop-types';
import Translations         from '../../utils/Translations';
import { trackFooterClick } from '../../utils/GAHelper';
import { generateKey } from '../../utils/CommonUtils';

class LanguageSelector extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			selectionVisible: false,
			selectedLanguage: this.props.initLanguage,
		};

		this.handleLanguageClick               = this.handleLanguageClick.bind(this);
		this.handleMouseLeaveLanguageSelection = this.handleMouseLeaveLanguageSelection.bind(this);
		this.handleSectionClick                = this.handleSectionClick.bind(this);
	}

	handleSectionClick() {
		!this.state.selectionVisible && trackFooterClick('language');
		this.setState({
			selectionVisible: !this.state.selectionVisible,
		});
	}

	handleLanguageClick(lang) {
		this.setState({
			selectionVisible: false,
			selectedLanguage: lang,
		});
	}

	handleMouseLeaveLanguageSelection() {
		this.setState({
			selectionVisible: false,
		});
	}


	render() {
		const languages = Object.keys(this.props.languageLinks).map((key, index) => {
			const handle = () => this.handleLanguageClick(key);

			const translation = "Language" + key.charAt(0).toUpperCase() + key.charAt(1);

			return (
				<a 
					key={generateKey(key, index)} 
					href={this.props.languageLinks[key]} 
					onClick={ handle } 
					className="footer__language"
				>
					<span className={'footer__language__item -language-' + key  } />
					{Translations.get(translation)}
				</a>
			);
		});

		const translationKey = "Language" + this.state.selectedLanguage.charAt(0).toUpperCase() + this.state.selectedLanguage.charAt(1);

		return (
			<div className="btn--icon -btn-color-footer -icon-earth-full -highlight-off -height-footer h-width-full"
			     onMouseLeave={this.handleMouseLeaveLanguageSelection}
			     onClick={this.handleSectionClick}
			>
				{Translations.get('FooterLanguageSelectionLabel')}:


				<div className="h-disp-inline-block">
					<span className="footer__currentlanguage">
						<span className={"footer__language__item -margin-left -language-" + this.state.selectedLanguage} />
						{Translations.get(translationKey)}
					</span>
					<div className={'footer__availablelanguages ' + ((this.state.selectionVisible) ? 'h-disp-block' : 'h-disp-hidden')}>
						{languages}
					</div>
				</div>
			</div>
		);
	}
}

LanguageSelector.propTypes = {
	initLanguage:  PropTypes.string,
	languageLinks: PropTypes.object,
};

export default LanguageSelector;
